// This file was auto-generated by Fern from our API Definition.
/** The asymmetric signing algorithm. */
const AsymmetricAlgorithmValues = {
    RsaSha256: "RSA_SHA256",
    RsaSha384: "RSA_SHA384",
    RsaSha512: "RSA_SHA512",
    EcdsaSha256: "ECDSA_SHA256",
    EcdsaSha384: "ECDSA_SHA384",
    EcdsaSha512: "ECDSA_SHA512",
    Ed25519: "ED25519",
};
export const AsymmetricAlgorithm = Object.assign(Object.assign({}, AsymmetricAlgorithmValues), { _visit: (value, visitor) => {
        switch (value) {
            case AsymmetricAlgorithm.RsaSha256:
                return visitor.rsaSha256();
            case AsymmetricAlgorithm.RsaSha384:
                return visitor.rsaSha384();
            case AsymmetricAlgorithm.RsaSha512:
                return visitor.rsaSha512();
            case AsymmetricAlgorithm.EcdsaSha256:
                return visitor.ecdsaSha256();
            case AsymmetricAlgorithm.EcdsaSha384:
                return visitor.ecdsaSha384();
            case AsymmetricAlgorithm.EcdsaSha512:
                return visitor.ecdsaSha512();
            case AsymmetricAlgorithm.Ed25519:
                return visitor.ed25519();
            default:
                return visitor._other();
        }
    } });
